import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SmartImage from 'dpl/components/SmartImage';

import dogComputerSvg from 'dpl/assets/dog_computer.svg';

export default function AboutGoodDogModule({ breedInfo, className }) {
  return (
    <div className={classnames('AboutGoodDogModule stone-700', className)}>
      <div className="row pv12 pv16-md">
        <div className="col-12 col-md-6">
          <h5 className="font-24 md:font-32 mb6 mb5-md">About Good Dog</h5>
          <div className="tc tl-l">
            <SmartImage src={dogComputerSvg} width="290px" height="217px" />
          </div>
        </div>
        <div className="col-12 col-md-6 self-center">
          <p className="font-16 md:font-20 md:font-serif mt6 mt0-md ph6-xl">
            {breedInfo}
          </p>
        </div>
      </div>
    </div>
  );
}

AboutGoodDogModule.propTypes = {
  breedInfo: PropTypes.string.isRequired,
  className: PropTypes.string
};

AboutGoodDogModule.defaultProps = {
  className: null
};
